import React from "react";
export function Jobs() {
	return (
		<div style={{ padding: 50 }}>
			<h2 style={{ fontFamily: "Coral" }}> Jobs </h2>
			<div style={{ width: "100%", paddingTop: 0 }}>
				<h3 style={{ fontFamily: "Coral" }}>
					Unity Developer - Remote
				</h3>
				<p>
					You: have a passion for making games. You are a C# wizard,
					who's worked in many code bases and can quickly and easily
					jump into existing projects. You thrive working on small,
					agile teams to move towards goals quickly. The prospect of
					working with Virtual Reality sound exciting to you.
				</p>
				<ul>
					<li> Three+ years of Unity Development. </li>
					<li> Three+ years of working with teams. </li>
					<li>
						{" "}
						You've worked on a game that has shipped and you'd be
						excited to talk about it.{" "}
					</li>
					<li> You have an entrepreneurial spririt</li>
				</ul>
				<p> If this sounds like you click the contact link above.</p>
			</div>
		</div>
	);
}
